import produce from 'immer'
import en from '../../translations/en'
import dk from '../../translations/dk'
import no from '../../translations/no'
import se from '../../translations/se'
import fi from '../../translations/fi'
import de from '../../translations/de'

import { TranslationActionType } from '../action-types'
import { TranslationAction } from '../actions/'
import Translation from '../state-types/TranslationStateType'
import config from '../../config'

const { env } = config

interface TranslationState {
    selectedTranslation: 'en' | 'dk' | 'se' | 'no' | 'fi' | 'de'
    // | 'nl' | 'fr'
    translation: Translation
}

const initialState: TranslationState = {
    selectedTranslation: env === 'production' ? 'dk' : 'en',
    // @ts-ignore — translation files have incomplete keys relative to Translation type
    translation: env === 'production' ? dk : en,
}

const reducer = produce(
    (state: TranslationState = initialState, action: TranslationAction) => {
        switch (action.type) {
            case TranslationActionType.SWITCH_LANGUAGE:
                state.selectedTranslation = action.payload
                // @ts-ignore — translation files have incomplete keys relative to Translation type
                state.translation = { en, dk, se, no, fi, de }[action.payload]

                return state
            default:
                return state
        }
    }
)

export default reducer
